module.exports = __webpack_public_path__ + "static/media/dini.d66d43bb.jpg";